import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Code', prop: 'code' },
  { title: 'Name', prop: 'name' },
  { title: 'Price', prop: 'price', format: 'currency' }
]

const defaults = {
  order: [{ column: 'code', direction: 'asc' }]
}

const filters = [
  { name: 'Filter by code', prop: 'filters.code_ilike', type: 'text', enabled: true },
  { name: 'Filter by name', prop: 'filters.name_ilike', type: 'text', enabled: true }
]

const Products = (props) => (
  <List
    title='Products'
    apiPath='admin/products'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default Products
